const $ = require('jquery');
import { HostController } from "./controllers/host.controller";
import { PlayerController } from "./controllers/player.controller";

export class Application {
	constructor() {
	}

	initialize() {
	
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        if (token) {
            this.intializePlayer(token);
        } else {
			this.promptMode();
            //this.initializeHost(!!urlParams.get('test'));
        }

	}

	promptMode() {

		const urlParams = new URLSearchParams(window.location.search);

		const container = $('<div class="boot-form"><h1>People Commander</h1></div>');
		$('#root').append(container);

		// Host button
		const hostButton = $('<button>Command a person</button>');
		container.append(hostButton);
		hostButton.on('click', () => {
			$('#root').empty();
			this.initializeHost(!!urlParams.get('test'));
		});

		container.append('<p>or</p>');
		container.append('<h2>Be commanded</h2>');

		// Player token form
		const playerForm = $('<form></form>');
		container.append(playerForm);

		const playerInput = $('<input placeholder="Enter token" type="number">');
		const playerButton = $('<button>Connect</button>');
		playerForm.append(playerInput);
		playerForm.append(playerButton);

		playerButton.on('click', () => {
			$('#root').empty();
			this.intializePlayer(playerInput.val() as string);
		});

	}

	initializeHost(openWindow: boolean = false) {

		const hostController = new HostController();
		hostController.initialize(openWindow);

	}

	intializePlayer(token: string) {

		const playerController = new PlayerController();
		playerController.initialize(token);

	}
}